export default "__VITE_ASSET__C$FP$tQ1__"